
const messages = {
  required: () => 'Это поле обязательно к заполнению',
  email: () => 'Укажите правильный email'
}

const dictionary = {
  en: {
    messages
  },
  ru: {
    messages
  }
}

export default (Validator) => {
  // Example of how to use a custom validator
  Validator.localize(dictionary)
}



// WEBPACK FOOTER //
// ./src/config/validations.js